/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Select from 'react-select';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    width: '100%',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '45px',
    fontSize: '14px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const SelectParameter = ({
  placeholder, form, setForm, parameter, options,
}) => (
  <Grid item md={12} style={{ minWidth: '500px' }}>
    <Select
      styles={customStyles}
      value={form[parameter]}
            // styles={customStyles}
      options={options}
      placeholder={placeholder}
      onChange={(e) => {
        setForm({ ...form, [parameter]: e });
      }}
    />
  </Grid>
);

SelectParameter.propTypes = {
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  parameter: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

export default SelectParameter;
